/**
 * observes('tree', 'assetPaths')
 *
 * Declares that a component renders those selections, so the cache knows to
 * keep them rebuilt while the component is on screen — and, more to the
 * point, to stop rebuilding them once it is gone.
 *
 * The dependency runs the way the layers do: the view states what it needs,
 * the cache decides what that costs and when to pay it. The view never
 * schedules a rebuild and never learns that a sync is in progress.
 *
 * Registration happens in created(), before the first render, so the
 * selection is already catching up while the component paints its loading
 * state. Release is automatic on destroy.
 *
 * @param {...string} names - keys on $wob that expose observe()
 */
export function observes(...names) {
  return {
    created() {
      this._wobObservers = names
        .map((name) => this.$wob[name])
        .filter((selection) => selection && selection.observe)
        .map((selection) => selection.observe())
    },
    destroyed() {
      if (!this._wobObservers) return
      this._wobObservers.forEach((release) => release())
      this._wobObservers = null
    },
  }
}
